import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { t } from '../../utils/creatorLang';
import { useCreatorAuth } from '../../utils/useCreatorAuth';
import {
  CreatorScreen, Card, Pill, BottomNav, ScreenHeader,
  I,
} from '../../components/creator/primitives';

const CreatorAgencyRules = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isDebugMode, tiktokId: authTiktokId } = useCreatorAuth();
  const qs = (isDebugMode && authTiktokId) ? `?creator=${authTiktokId}` : (searchParams.get('creator') ? `?creator=${searchParams.get('creator')}` : '');

  const rules = [
    { iconKey: 'Alert', tint: 'red', title: t('ar_1_title'), desc: t('ar_1_desc'), critical: true },
    { iconKey: 'Clock', tint: 'pink', title: t('ar_2_title'), desc: t('ar_2_desc') },
    { iconKey: 'Calendar', tint: 'cyan', title: t('ar_3_title'), desc: t('ar_3_desc') },
    { iconKey: 'Eye', tint: 'gold', title: t('ar_4_title'), desc: t('ar_4_desc') },
    { iconKey: 'Shield', tint: 'cyan', title: t('ar_5_title'), desc: t('ar_5_desc') },
    { iconKey: 'Sparkle', tint: 'gold', title: t('ar_6_title'), desc: t('ar_6_desc') },
  ];

  return (
    <CreatorScreen>
      <div className="screen grain">
        <ScreenHeader
          title={t('ar_title')}
          subtitle={t('ar_sub')}
          onBack={() => navigate(`/my/dashboard${qs}`)}
        />

        {/* Warning */}
        <div style={{ padding: '0 20px 14px' }}>
          <div style={{
            padding: 14, borderRadius: 16,
            background: 'var(--accent-red-soft)',
            border: '1px solid oklch(0.65 0.24 25 / 0.25)',
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <I.Alert size={18} stroke="var(--accent-red)"/>
            <div style={{ fontSize: 12, color: 'var(--fg-1)', lineHeight: 1.4 }}>
              {t('ar_warning')}
            </div>
          </div>
        </div>

        {/* Rules list */}
        <div style={{ padding: '0 20px 14px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {rules.map((r, i) => {
            const IconC = I[r.iconKey];
            return (
              <Card key={i} pad={16} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 12,
                  background: `var(--accent-${r.tint}-soft)`,
                  border: `1px solid oklch(from var(--accent-${r.tint}) l c h / 0.25)`,
                  display: 'grid', placeItems: 'center', flexShrink: 0,
                }}>
                  <IconC size={18} stroke={`var(--accent-${r.tint})`}/>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--fg-0)' }}>{r.title}</span>
                    {r.critical && <Pill color="red" style={{ padding: '2px 6px', fontSize: 9, letterSpacing: 0.3 }}>{t('ar_critical')}</Pill>}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--fg-2)', lineHeight: 1.5 }}>{r.desc}</div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Footer */}
        <div style={{ padding: '0 20px' }}>
          <Card pad={14} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <I.Info size={18} stroke="var(--fg-2)"/>
            <div style={{ fontSize: 11, color: 'var(--fg-2)', lineHeight: 1.5 }}>
              {t('ar_footer')}
            </div>
          </Card>
        </div>
      </div>

      <BottomNav active="" qs={qs}/>
    </CreatorScreen>
  );
};

export default CreatorAgencyRules;
